import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { getHomepageUrl } from '@as-react/common-utils';
import { Box, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomerApi from '../../api/customer/CustomerApi';
import { PasswordResetForm, PasswordResetFormView, } from '../../components/password-reset-form/PasswordResetForm';
import { DELAY } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { getQuerystringByName } from '../../util/URLParamUtil';
const EVENT_PARAM_KEY = 'event';
const EXT_ID_PARAM_KEY = 'ext_id';
const AccountPasswordResetContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint, root } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.buy, I18N_NAMESPACES.navigation]);
    const [customerUUID, setCustomerUUID] = useState('');
    const [extId, setExtId] = useState(undefined);
    const [isValidUUID, setIsValidUUID] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const [buttonState, setButtonState] = useState('interactive');
    const [isSuccess, setIsSuccess] = useState(false);
    const [errorFeedback, setErrorFeedback] = useState('');
    useEffect(() => {
        var _a;
        const validateUUID = (uuid, extId) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield CustomerApi.validatePasswordResetLink(servicesEndpoint, defaultRequestParams, uuid, extId);
                setIsValidUUID(true);
                setShouldRender(true);
            }
            catch (_a) {
                setShouldRender(true);
            }
        });
        const uuid = (_a = getQuerystringByName(window.location.search, EVENT_PARAM_KEY)) !== null && _a !== void 0 ? _a : '';
        const extId = getQuerystringByName(window.location.search, EXT_ID_PARAM_KEY) || undefined;
        setCustomerUUID(uuid);
        setExtId(extId);
        validateUUID(uuid, extId);
    }, []);
    const handleSubmitDefault = (values) => __awaiter(void 0, void 0, void 0, function* () {
        setButtonState('loading');
        try {
            yield CustomerApi.resetPassword(servicesEndpoint, defaultRequestParams, customerUUID, values.password, extId);
            setIsSuccess(true);
            setButtonState('interactive');
            if (errorFeedback) {
                setErrorFeedback('');
            }
            setTimeout(() => (window.location.href = getHomepageUrl(root)), DELAY.DELAY_3000);
        }
        catch (_a) {
            setButtonState('interactive');
            setErrorFeedback(t('account:account.reset.password.error'));
        }
    });
    const handleSubmitEmail = (values) => __awaiter(void 0, void 0, void 0, function* () {
        setButtonState('loading');
        try {
            yield CustomerApi.sendPasswordResetMail(servicesEndpoint, defaultRequestParams, values.email);
            setIsSuccess(true);
            setButtonState('interactive');
            if (errorFeedback) {
                setErrorFeedback('');
            }
            setTimeout(() => (window.location.href = getHomepageUrl(root)), DELAY.DELAY_3000);
        }
        catch (_a) {
            setButtonState('interactive');
            setErrorFeedback(t('navigation:flyout.account.error.operation.mail'));
        }
    });
    if (!shouldRender)
        return null;
    return (_jsx(Box, { paddingBlockStart: { base: '6', md: '7' }, paddingBlockEnd: { base: '10', md: '12', lg: '14' }, children: _jsxs(Box, { shadow: !isMobile ? 'lg' : undefined, paddingBlockEnd: { base: '4', md: '6', lg: '12' }, paddingBlockStart: { base: '6', md: '10' }, backgroundColor: "quiet", paddingInline: { base: '4', md: '12' }, marginInline: { base: '-4', md: '0' }, children: [isValidUUID ? (_jsx(_Fragment, { children: title.show && (_jsx(Box, { paddingBlockEnd: { base: '4', md: '8' }, children: _jsx(TextAlpha, { as: "h2", variant: "subheadingXL", children: title.value || t('account:account.password.passwordOne') }) })) })) : (_jsxs(_Fragment, { children: [_jsx(TextAlpha, { as: "h2", variant: "subheadingS", children: t('account:account.reset.password.invalidtoken') }), _jsx(Box, { paddingBlockEnd: "6", paddingBlockStart: "3", children: _jsx(TextAlpha, { as: "p", variant: "bodyS", children: t('account:account.passwordForgottenText') }) })] })), _jsx(PasswordResetForm, { onSubmit: isValidUUID ? handleSubmitDefault : handleSubmitEmail, view: isValidUUID ? PasswordResetFormView.DEFAULT : PasswordResetFormView.EMAIL, buttonState: buttonState, isSuccess: isSuccess, errorFeedback: errorFeedback })] }) }));
};
export default AccountPasswordResetContainer;
